<div class="grid grid-cols-2 gap-[0.75rem] lg:gap-6">
  @for (territory of availableTerritories; track territory) {
    <div class="group w-full rounded-xl lg:rounded-3xl relative overflow-hidden h-40 sm:h-44 md:h-52 lg:h-72 xl:h-[22rem] 2xl:h-[430px] cursor-pointer transition-all"
      (click)="goToXplorerTerritory(territory)">
      <img
        [src]="getTerritoryBackground(territory.code)"
        [alt]="territory.name"
        loading="lazy"
        decoding="async"
        fetchpriority="low"
        class="absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-in-out sm:group-hover:scale-110">
      @if (isBrowser && territory.code === currentTerritoryCode) {
        <div
          class="absolute top-3 md:top-10 right-3 md:right-10 z-50 text-white">
          <div class="flex flex-col gap-y-1 md:gap-y-2 items-center">
            <img [src]="ImageManager.getWhiteLogoIconTerritory()" [alt]="territory.name" class="w-[14px] md:w-[31px] h-[18px] md:h-10">
            <p class="text-[8px] lg:text-xs text-medium text-white">Sei qui!</p>
          </div>
        </div>
      }
      <div class="relative z-10 w-full h-full flex justify-center items-center">
        <img [src]="ImageManager.getWhiteLogoHomeByTerritoryCode(territory.code)" [alt]="territory.name"
          class="w-[132px] h-[29px] lg:w-[331px] lg:h-[79px]">
      </div>
    </div>
  }
  </div>
